var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "467px",
    height: "464px",
    viewBox: "0 0 467 464",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "center") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(-52.000000, -52.000000)",
    fill: "#A0A0A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 285.117647,
    cy: 283.75,
    rx: 128.117647,
    ry: 125.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.134525,515.13125 C156.377882,515.13125 52,411.679646 52,284.065625 C52,156.451604 156.377882,52.9999999 285.134525,52.9999999 C413.891167,52.9999999 518.269049,156.451604 518.269049,284.065625 C518.269049,411.679646 413.891167,515.13125 285.134525,515.13125 Z M285.134525,496.45928 C403.48659,496.45928 499.429896,401.367402 499.429896,284.065625 C499.429896,166.763848 403.48659,71.6719696 285.134525,71.6719696 C166.782459,71.6719696 70.8391535,166.763848 70.8391535,284.065625 C70.8391535,401.367402 166.782459,496.45928 285.134525,496.45928 Z",
    id: "ring",
    transform: "translate(285.134525, 284.065625) rotate(15.000000) translate(-285.134525, -284.065625) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.e90633c6f5a5f82aeb012b682edcaac8.svg";
export { ForwardRef as ReactComponent };